// src/components/Footer.js
import React from 'react';
import { FaTwitter, FaGoogle, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="flex justify-between items-center p-4 bg-white border-t">
      <div className="text-lg font-semibold">
        Transforming Digital Trust With Swift, <span className="text-blue-600">Secure Blockchain Tokenization</span>.
      </div>
      <div className="flex items-center space-x-4">
        <FaTwitter size={24} />
        <FaGoogle size={24} />
        <FaLinkedin size={24} />
        <div className="flex space-x-4">
          <a href="/terms" className="text-sm text-gray-500">Terms & Conditions</a>
          <a href="/privacy" className="text-sm text-gray-500">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
